<div class="text-right" *ngIf="data$ | async as data">{{ data | accountsNumber: 1 }}</div>
